<app-error-card
  title="404 Not Found"
  message="Sorry we couldn't find the page you are looking for. If you think this is
  a mistake please contact your site administrator."
>
  <a class="btn btn-primary" (click)="onCancel()"
    ><i class="bi bi-arrow-left"></i> Return</a
  >
</app-error-card>
